export const environment = {
  production: false,
  bffUrl: 'https://buildingmanagementapi.azurewebsites.net',
  test: true,
  relihUrl: 'https://www.habitat.org/emea/stories/rely-reelih',
  habitatUrl: 'http://habitat.org.mk/',
  mailto: 'info@habitat.org.mk',
};
